import { useIntl } from 'react-intl';
import { Col, Form, Input, Row, Select } from 'antd';

import { useEffect } from 'react';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import {
  DirectSaleStatusEnum,
  ListDirectSaleQuery,
} from '@/core/domain/sales/DirectSale/DirectSale.types';
import {
  CompaniesInfiniteSelectField,
  InputDate,
  InputText,
} from '@/components/_common';
import { DateTimeFormat } from '@/utils/moment';
import moment from 'moment';
import ManufacturerInfiniteSelectField from '@/components/_common/ManufacturerInfiniteSelectField';
import PartsInfiniteSelectField from '@/components/_common/PartsInfiniteSelectField';
import DirectSaleTagsInfiniteSelectField from '@/components/_common/DirectSaleTagsInfiniteSelectField';

function DirectSaleExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListDirectSaleQuery>) {
  const intl = useIntl();
  const [form] = Form.useForm<ListDirectSaleQuery>();

  useEffect(() => {
    form.setFieldsValue({ ...queryParams });
  }, [queryParams]);

  const handleValuesChange = (_: unknown, values: ListDirectSaleQuery) => {
    setQueryParams((prev) => ({
      ...prev,
      ...values,
    }));
  };

  return (
    <Form onValuesChange={handleValuesChange} form={form}>
      <Row gutter={[16, 16]}>
        <Col lg={8} span={24}>
          <Form.Item noStyle name="code">
            <InputText
              onlyNumber
              placeholder={intl.formatMessage({
                id: 'directSale.columns.table.code',
              })}
            />
          </Form.Item>
        </Col>

        <Col lg={8} span={24}>
          <Form.Item noStyle name="customerName">
            <Input
              placeholder={intl.formatMessage({
                id: 'directSale.columns.table.customer',
              })}
            />
          </Form.Item>
        </Col>

        <Col lg={8} span={24}>
          <Form.Item noStyle name="companyId">
            <CompaniesInfiniteSelectField
              placeholder={intl.formatMessage({
                id: 'directSale.columns.table.company',
              })}
              allowClear
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>

        <Col span={24} md={12} lg={6}>
          <Form.Item noStyle name="manufacturerId">
            <ManufacturerInfiniteSelectField
              allowClear
              placeholder="Fabricante"
            />
          </Form.Item>
        </Col>

        <Col span={24} md={12} lg={6}>
          <InputDate
            placeholder={intl.formatMessage({
              id: 'directSale.columns.table.dateOfSale',
            })}
            value={
              queryParams?.createDate
                ? moment(queryParams?.createDate)
                : undefined
            }
            onChange={(values) =>
              setQueryParams((prev) => ({
                ...prev,
                createDate: values?.format(DateTimeFormat),
              }))
            }
          />
        </Col>

        <Col span={24} md={12} lg={6}>
          <Form.Item noStyle name="status">
            <Select
              mode="multiple"
              allowClear
              style={{ width: '100%' }}
              placeholder={intl.formatMessage({
                id: 'directSale.columns.table.status',
              })}
              options={[
                {
                  value: DirectSaleStatusEnum.OPEN,
                  label: intl.formatMessage({
                    id: 'directSale.OPEN',
                  }),
                },
                {
                  value: DirectSaleStatusEnum.AUTHORIZED,
                  label: intl.formatMessage({
                    id: 'directSale.AUTHORIZED',
                  }),
                },
                {
                  value: DirectSaleStatusEnum.CANCELED,
                  label: intl.formatMessage({
                    id: 'directSale.CANCELED',
                  }),
                },
              ]}
            />
          </Form.Item>
        </Col>

        <Col span={24} md={12} lg={6}>
          <Form.Item noStyle name="tagsIds">
            <DirectSaleTagsInfiniteSelectField
              allowClear
              mode="multiple"
              placeholder="Etiquetas"
            />
          </Form.Item>
        </Col>

        <Col span={24} md={12} lg={6}>
          <Form.Item noStyle name="partId">
            <PartsInfiniteSelectField placeholder="Peça" allowClear />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}

export default DirectSaleExtraFilters;
